import {
  ADD_UPDATE_CONFIGURATION_DETAILS_FAILURE,
  ADD_UPDATE_CONFIGURATION_DETAILS_REQUEST,
  ADD_UPDATE_CONFIGURATION_DETAILS_SUCCESS,
  GET_CONFIGURATION_DETAILS_FAILURE,
  GET_CONFIGURATION_DETAILS_REQUEST,
  GET_CONFIGURATION_DETAILS_SUCCESS,
} from "./actionTypes";

export const getConfigurationDetailsRequest = (url: string) => ({
  type: GET_CONFIGURATION_DETAILS_REQUEST,
  url,
});

export const getConfigurationDetailsSuccess = (configurationDetails: any) => ({
  type: GET_CONFIGURATION_DETAILS_SUCCESS,
  payload: { configurationDetails },
});

export const getConfigurationDetailsFailure = (error: string) => ({
  type: GET_CONFIGURATION_DETAILS_FAILURE,
  payload: error,
});

export const addUpdateConfigurationDetailsRequest = (
  url: string,
  payload: any,
  callback: unknown
) => ({
  type: ADD_UPDATE_CONFIGURATION_DETAILS_REQUEST,
  url,
  payload,
  callback
});

export const addUpdateConfigurationDetailsSuccess = (
  successMessage: string
) => ({
  type: ADD_UPDATE_CONFIGURATION_DETAILS_SUCCESS,
  payload: { successMessage },
});

export const addUpdateConfigurationDetailsFailure = (error: string) => ({
  type: ADD_UPDATE_CONFIGURATION_DETAILS_FAILURE,
  payload: error,
});
